import * as React from 'react';
import noop from 'lodash/noop';
import { useIntl } from 'react-intl';
import { TextArea, Text } from '@box/blueprint-web';
import classNames from 'classnames';
import useId from '../../utils/useId';
import messages from './messages';
import css from './file-description-text-area.module.scss';
import RequiredMark from '../required-mark';
import { MAX_DESCRIPTION_OF_UPLOADED_FILE_LENGTH } from '../../../constants';

const FileDescriptionTextArea = (props: {
  disabled: boolean;
  error?: React.ReactNode;
  isRequired?: boolean;
  onChange?: (...args: unknown[]) => unknown;
}) => {
  const { onChange = noop, isRequired, disabled = false, error = null } = props;
  const intl = useIntl();

  const renderLabel = isRequired ? (
    <>
      {intl.formatMessage(messages.fileDescriptionLabel)} <RequiredMark />
    </>
  ) : (
    intl.formatMessage(messages.fileDescriptionLabel)
  );

  const labelID = useId('label');

  const ariaAttrs = {
    'aria-labelledby': labelID,
  } as const;

  return (
    <div
      className={css.fileDescriptionContainer}
      data-testid="upload-zone-description-text-area"
    >
      <Text
        id={labelID}
        as="label"
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2820
        color="text-on-light-default"
        variant="subtitle"
        className={css.label}
      >
        {renderLabel}
      </Text>
      {/*
       // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322 */}
      <TextArea
        className={classNames({ [css.textArea]: disabled })}
        disabled={disabled}
        error={error}
        required={isRequired}
        maxRows={5}
        minRows={3}
        onChange={onChange}
        maxLength={MAX_DESCRIPTION_OF_UPLOADED_FILE_LENGTH}
        placeholder={intl.formatMessage(messages.fileDescriptionPlaceholder)}
        {...ariaAttrs}
      />
    </div>
  );
};

export { FileDescriptionTextArea };
export default FileDescriptionTextArea;
